/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_NameInputs */

const en_tables_skill_groups_name = /** @type {(inputs: Tables_Skill_Groups_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Name`)
};

const de_tables_skill_groups_name = /** @type {(inputs: Tables_Skill_Groups_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Groups Name" |
*
* @param {Tables_Skill_Groups_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_name = /** @type {((inputs?: Tables_Skill_Groups_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_name(inputs)
	return de_tables_skill_groups_name(inputs)
});